import { ref } from "vue";

// Default value for snackbar
const snackbar = ref({
    title: "",
    message: "Lorem ipsum dolor sit amet consectetur!",
    visible: false,
    timeout: 3000,
    color: "success",
    location: "bottom",
    avatar_url: null,
    button_text: null,
    button_url: null,
});

const snackbars = ref([]);

const snackbar_clicked_outside = ref(false);

export default function utilities() {
    function setSnackbar(obj) {
        snackbar.value.title = obj?.title || "";
        snackbar.value.message = obj?.message || "";
        snackbar.value.visible = obj?.visible || snackbar.value.visible;
        snackbar.value.timeout = obj?.timeout || snackbar.value.timeout;
        snackbar.value.color = obj?.color || snackbar.value.color;
        snackbar.value.location = obj?.location || snackbar.value.location;
        snackbar.value.avatar_url = obj?.avatar_url || null;
        snackbar.value.button_text = obj?.button_text || null;
        snackbar.value.button_url = obj?.button_url || null;
        snackbar.value.icon = obj?.icon || snackbar.value.icon;
        snackbar.value.class = obj?.class || snackbar.value.class;
    }

    function toggleSnackBarOff() {
        snackbar.value.visible = false;
    }

    function toggleSnackBarOn() {
        snackbar.value.visible = true;
    }

    function toggleSnackBar(obj) {
        snackbar.value.visible = false;

        let to = setTimeout(() => {
            snackbar.value.title = obj?.title || "";
            snackbar.value.message = obj?.message || "";
            snackbar.value.timeout = obj?.timeout || snackbar.value.timeout;
            snackbar.value.color = obj?.color || snackbar.value.color;
            snackbar.value.location = obj?.location || snackbar.value.location;
            snackbar.value.avatar_url = obj?.avatar_url;
            snackbar.value.button_text = obj?.button_text;
            snackbar.value.button_url = obj?.button_url;
            snackbar.value.visible = true;
            snackbar.value.icon = obj?.icon || snackbar.value.icon;
            snackbar.value.class = obj?.class || snackbar.value.class;
            clearTimeout(to);
        }, 50);
    }

    function showSnackbar(
        message,
        type,
        avatar_url = null,
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        toggleSnackBarOff();
        setSnackbar({
            message: message,
            visible: false,
            timeout: timeout,
            color: type,
            location: "bottom center",
            avatar_url: avatar_url,
            button_text: button_text,
            button_url: button_url,
        });
        toggleSnackBarOn();
    }

    function showStackedSnackbar(
        message,
        type,
        avatar_url = null,
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        addSnackbar({
            message: message,
            timeout: timeout,
            color: type,
            avatar_url: avatar_url,
            button_text: button_text,
            button_url: button_url,
        });
    }

    function addSnackbar(obj) {
        snackbars.value.push({
            title: obj?.title || "",
            message: obj?.message || "",
            visible: true,
            timeout: obj?.timeout || 3000,
            color: obj?.color || "info",
            location: obj?.location || "bottom right",
            avatar_url: obj?.avatar_url || null,
            button_text: obj?.button_text || null,
            button_url: obj?.button_url || null,
            icon: obj?.icon || null,
        });
    }

    function showSuccessSnackbar(
        message,
        avatar_url = null,
        type = "success",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function showErrorSnackbar(
        message,
        avatar_url = null,
        type = "error",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function showInfoSnackbar(
        message,
        avatar_url = null,
        type = "info",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function showInteractiveSnackbar(
        message,
        avatar_url = null,
        type = "info",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showStackedSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function setSnackbarClickedOutside() {
        snackbar_clicked_outside.value = true;
    }

    return {
        // States
        snackbar,
        snackbars,
        snackbar_clicked_outside,

        // Functions
        setSnackbar,
        toggleSnackBarOff,
        toggleSnackBarOn,
        toggleSnackBar,
        showInteractiveSnackbar,
        showSuccessSnackbar,
        showInfoSnackbar,
        showErrorSnackbar,
        setSnackbarClickedOutside,
    };
}
